import { render, staticRenderFns } from "./SpecimenType.vue?vue&type=template&id=3dbfbe2b&scoped=true&"
import script from "./SpecimenType.vue?vue&type=script&lang=js&"
export * from "./SpecimenType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbfbe2b",
  null
  
)

export default component.exports